import React, { useState, useEffect } from "react";
import { logApi } from "../../api/Api";

const SolarLoadSvg = ({ svgColor }) => {
    const [logData, setLogData] = useState(null); // Initialize as null or an object
    const [credentials, setCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });

    const fetchLogData = async () => {
        try {
            const res = await logApi(credentials);
            if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
                // Assuming you need the first object in the array
                setLogData(res.TOT_LIVE_KW_NEW[0]);
            } else {
                setLogData(null); // Handle no data scenario
            }
        } catch (error) {
            console.error("Error fetching log data:", error);
            setLogData(null); // Handle error scenario
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials]);



    // Determine the color for the SOLAR value
    const solarColor =
        logData?.SOLAR == null
            ? "gray" // No data
            : logData.SOLAR <= 0
                ? "red" // Solar < 1
                : "green"; // Solar >= 1

    // Determine the color for the LOAD value
    const loadColor =
        logData?.TOTAL_LOAD == null
            ? "gray" // No data
            : logData.TOTAL_LOAD <= 0
                ? "red" // Solar < 1
                : "green"; // Solar >= 1


    // Determine the color for the DG value
    const dgColor =
        logData?.GenSet == null
            ? "gray" // No data
            : logData.GenSet <= 0
                ? "red" // Solar <= 0
                : "green"; // Solar > 0





    return (
        <>

            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="100%" height="400px" viewBox="0 0 389.000000 389.000000"
                preserveAspectRatio="xMidYMid meet">

                <g transform="translate(-370.000000,1640.000000) scale(0.100000,-0.100000)"
                    fill="#000000" stroke={svgColor}>
                    <path d="M2880 16161 c0 -17 5 -31 10 -31 6 0 10 11 10 24 0 14 -4 28 -10 31
-6 4 -10 -7 -10 -24z" fill={solarColor}/>
                    <path d="M2760 16148 c0 -9 9 -26 20 -39 19 -23 19 -23 20 -3 0 11 -9 29 -20
39 -17 15 -20 16 -20 3z" fill={solarColor}/>
                    <path d="M2985 16129 c-4 -11 -4 -23 0 -27 7 -7 25 17 25 36 0 20 -18 14 -25
-9z" fill={solarColor}/>
                    <path d="M2823 16059 c-83 -41 -100 -164 -32 -228 33 -30 44 -26 59 22 26 88
32 94 110 101 39 4 70 12 70 18 0 27 -43 77 -80 92 -53 21 -77 20 -127 -5z" fill={solarColor}/>
                    <path d="M2670 16062 c0 -15 24 -32 44 -32 18 0 19 1 1 20 -18 20 -45 27 -45
12z" fill={solarColor}/>
                    <path d="M3059 16052 c-28 -23 -11 -37 19 -16 22 15 29 34 13 34 -5 0 -19 -8
-32 -18z" fill={solarColor}/>
                    <path d="M2640 15940 c0 -5 15 -10 33 -10 24 0 28 3 17 10 -20 13 -50 13 -50
0z" fill={solarColor}/>
                    <path d="M2896 15908 c-2 -7 -9 -28 -15 -45 l-10 -33 59 0 c54 0 60 2 65 23
13 62 14 62 -43 65 -36 2 -53 -1 -56 -10z" fill={solarColor}/>
                    <path d="M3031 15883 c-6 -21 -11 -41 -11 -45 0 -5 29 -8 65 -8 l65 0 0 29 c0
16 3 36 6 45 5 14 -3 16 -54 16 l-61 0 -10 -37z" fill={solarColor}/>
                    <path d="M3187 15913 c-4 -3 -7 -26 -7 -50 l0 -43 75 0 75 0 0 50 0 50 -68 0
c-38 0 -72 -3 -75 -7z" fill={solarColor}/>
                    <path d="M3350 15870 l0 -50 48 0 c26 0 57 3 68 6 19 5 21 9 12 44 -9 35 -13
38 -55 44 -75 10 -73 11 -73 -44z" fill={solarColor}/>
                    <path d="M3505 15883 c10 -53 10 -53 71 -53 48 0 55 2 50 18 -3 9 -8 29 -12
45 -6 25 -9 27 -61 27 l-55 0 7 -37z" fill={solarColor}/>
                    <path d="M2686 15835 c-11 -8 -17 -18 -13 -22 9 -8 57 14 57 27 0 14 -22 12
-44 -5z" fill={solarColor}/>
                    <path d="M2921 15791 l-64 -6 -13 -45 c-7 -24 -11 -46 -9 -48 2 -2 32 0 66 5
l63 8 12 48 c6 26 11 46 10 45 0 -1 -30 -4 -65 -7z" fill={solarColor}/>
                    <path d="M3005 15749 c-4 -22 -5 -42 -3 -44 3 -3 99 -8 124 -6 7 1 14 21 16
46 l3 45 -67 0 -66 0 -7 -41z" fill={solarColor}/>
                    <path d="M3177 15783 c-4 -3 -7 -24 -7 -45 l0 -38 86 0 c85 0 86 0 80 23 -3
12 -6 32 -6 45 0 21 -4 22 -73 22 -41 0 -77 -3 -80 -7z" fill={solarColor}/>
                    <path d="M3360 15761 c0 -56 6 -61 82 -61 l71 0 -7 32 c-10 49 -23 58 -87 58
-58 0 -59 0 -59 -29z" fill={solarColor}/>
                    <path d="M3524 15773 c3 -10 8 -30 12 -45 6 -27 9 -28 70 -28 35 0 64 3 64 6
0 4 -5 24 -12 45 l-11 39 -64 0 c-57 0 -64 -2 -59 -17z" fill={solarColor}/>
                    <path d="M2770 15761 c-12 -24 -13 -41 -2 -41 8 0 32 43 32 55 0 13 -21 3 -30
-14z" fill={solarColor}/>
                    <path d="M2811 15638 c-5 -13 -12 -38 -16 -56 l-7 -33 73 3 73 3 11 53 12 52
-69 0 c-62 0 -69 -2 -77 -22z" fill={solarColor}/>
                    <path d="M2976 15623 c-12 -76 -15 -73 75 -73 l80 0 -3 53 -3 52 -71 3 -71 3
-7 -38z" fill={solarColor}/>
                    <path d="M3160 15605 l0 -55 95 0 95 0 0 33 c0 75 -3 77 -101 77 l-89 0 0 -55z" fill={solarColor} />
                    <path d="M3375 15649 c-4 -6 -4 -30 0 -55 l6 -44 80 0 c49 0 79 4 79 11 0 5
-5 30 -11 55 l-11 44 -69 0 c-37 0 -71 -5 -74 -11z" fill={solarColor}/>
                    <path d="M3563 15652 c-8 -5 -9 -19 0 -55 l10 -47 69 0 c76 0 77 2 56 71 l-11
39 -56 0 c-31 0 -61 -4 -68 -8z" fill={solarColor}/>
                    <path d="M3914 15545 c-3 -8 -3 -19 1 -25 4 -7 149 -10 441 -10 l434 0 0 -560
0 -560 201 0 201 0 -21 -35 c-11 -19 -16 -35 -10 -35 6 0 51 19 100 42 72 33
87 44 77 54 -12 11 -172 84 -184 84 -3 0 2 -10 10 -22 9 -12 16 -26 16 -30 0
-5 -76 -8 -170 -8 l-170 0 0 560 0 560 -460 0 c-394 0 -461 -2 -466 -15z" fill={svgColor}/>
                    <path d="M2784 15512 c-6 -4 -19 -32 -29 -62 -10 -30 -20 -61 -23 -68 -3 -10
14 -12 79 -10 l83 3 13 50 c24 92 22 95 -49 95 -35 0 -68 -4 -74 -8z" fill={solarColor}/>
                    <path d="M2964 15512 c-11 -6 -34 -95 -34 -127 0 -12 18 -15 89 -15 102 0 101
-1 101 91 l0 59 -72 0 c-40 0 -78 -4 -84 -8z" fill={solarColor}/>
                    <path d="M3150 15498 c0 -13 -3 -47 -6 -75 l-7 -53 112 0 111 0 0 29 c0 15 -3
49 -6 75 l-7 46 -98 0 c-96 0 -99 -1 -99 -22z" fill={solarColor}/>
                    <path d="M3385 15453 c4 -38 9 -71 12 -75 2 -5 42 -8 88 -8 46 0 86 3 88 8 2
4 -3 37 -11 75 l-15 67 -84 0 -85 0 7 -67z" fill={solarColor}/>
                    <path d="M3580 15514 c0 -3 7 -36 16 -75 l16 -69 79 0 c43 0 79 4 79 9 0 5 -9
39 -20 75 l-21 66 -74 0 c-41 0 -75 -2 -75 -6z" fill={solarColor}/>
                    <path d="M3230 15260 c0 -79 0 -80 25 -80 25 0 25 1 25 80 0 79 0 80 -25 80
-25 0 -25 -1 -25 -80z" fill={solarColor}/>
                    <path d="M2940 15110 l-75 -39 383 -1 c210 0 382 2 382 5 0 3 -32 21 -72 40
l-72 35 -236 0 -235 -1 -75 -39z" fill={solarColor}/>
                    <path d="M5709 14811 c-189 -40 -324 -237 -292 -427 23 -131 93 -228 205 -283
234 -116 500 39 533 309 24 196 -141 391 -342 404 -37 3 -84 1 -104 -3z m153
-32 c103 -22 187 -92 237 -198 22 -47 26 -69 25 -141 -1 -111 -36 -193 -113
-262 -73 -66 -144 -91 -241 -86 -132 8 -230 71 -296 191 -26 48 -29 60 -29
157 0 100 2 107 33 160 92 157 216 214 384 179z" fill={svgColor}/>
                    <path d="M6214 14425 c-3 -8 -3 -19 1 -25 4 -7 149 -10 441 -10 l434 0 0 -560
0 -560 201 0 201 0 -21 -35 c-11 -19 -16 -35 -10 -35 6 0 51 19 100 42 72 33
87 44 77 54 -12 11 -172 84 -184 84 -3 0 2 -10 10 -22 9 -12 16 -26 16 -30 0
-5 -76 -8 -170 -8 l-170 0 0 560 0 560 -460 0 c-394 0 -461 -2 -466 -15z" fill={svgColor}/>
                    <path d="M8192 13923 c-414 -366 -492 -436 -492 -442 0 -4 12 -19 28 -33 l27
-26 90 80 c182 164 420 370 432 375 6 2 122 -94 258 -214 136 -120 255 -224
266 -232 17 -12 21 -11 39 10 10 13 19 29 20 36 0 11 -123 123 -417 381 l-163
142 -88 -77z" fill={loadColor}/>
                    <path d="M7870 13830 c0 -55 3 -100 6 -100 11 0 99 81 116 108 40 60 15 92
-71 92 l-51 0 0 -100z" fill={loadColor}/>
                    <path d="M8180 13709 c-52 -45 -143 -127 -202 -181 l-108 -100 0 -269 0 -269
134 0 133 0 5 115 c2 63 8 118 12 122 4 5 61 8 127 8 96 0 122 -3 129 -15 5
-8 10 -63 10 -122 l0 -108 135 0 135 0 0 269 0 268 -122 114 c-169 158 -274
249 -284 249 -5 0 -52 -37 -104 -81z" fill={loadColor}/>
                </g>
            </svg>


        </>
    );
};

export default SolarLoadSvg;